import includes from "array-includes";
const local = window.location.href.indexOf("localhost") !== -1;

export default {
  api: local ? "http://localhost:8000/" : "https://api.docuvaultapp.com/",
};
